<template lang="pug">
  main
    NavBarSolicitudes
    Loader(v-show="isLoading")
    ModalAceptar(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:acepted="aceptarSolicitud")
    ModalRechazar(v-show="modalStatusRechazar" :title="titleModalR" :content="contentModalR" @padre:rechazar="rechazarSolicitud")
    ModalCancelarRechazo(v-show="modalStatusCancelR" :title="titleModalCancelR" :content="contentModalCancelR" @padre:cancelRechazo="cancelarRechazo")
    ModalDeshacer(v-show="modalStatusDeshacer" :title="titleModalDeshacer" :content="contentModalDeshacer" @padre:cancelarSol="deshacerAceptar")
    ModalEstadoAnterior(v-show="modalStatusAnterior_Next" :title="titleModalAnterior_Next" :content="contentModalAnterior_Next" @padre:anterior_next="anterior_next")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Solicitudes
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns(v-show="hayDatos")
          .column.is-full
            .table-responsive
              table.table.table-hover.table-sm.is-fullwidth
                thead
                  tr
                    th.th-description #
                    th.th-description Descripción (Equipo, Cantidad, Fecha)
                    th.th-description Razón
                    th.th-description Ubicación
                    th.th-description Solicita
                    th.th-description Prioridad
                    th.th-description Estado
                tbody
                  tr(v-for="(sol, index) in solicitudes" :id="sol.id")
                    td 
                      span.tag.is-black(@click="irSocilitud(sol.id)") {{ index + 1 }} 
                    td 
                      b Equipo: 
                        small {{ sol.equipo }}
                      br
                      small(v-if="sol.area === '3'") 💻 Cant. {{ sol.cantidad }} | Fecha Reg. {{ sol.fechaReg}}
                      small(v-else) 📟 Cant. {{ sol.cantidad }} | Fecha Reg. {{ sol.fechaReg}}
                    td
                      span.tag.is-dark
                        | {{ `P: ${sol.fechaReg}: ${sol.razon}` }}
                      br
                      button.button.is-text.is-small(v-show="sol.id_actividad!==''" @click="imprimirReporte(sol)")
                        | {{ sol.id_actividad }}
                    td {{ sol.ubicacion }}
                    td {{ sol.solicita }}
                    td(v-html="getPrioridad(sol.prioridad)")
                    td(v-html="getEstado(sol.estado, sol.departamento, sol.area)" @click="cambiarEstado(sol)")
        .columns(v-show="!hayDatos")
          .column.is-offset-one-third.is-one-third
            .notification.is-warning
              button.delete
              |   No hay registros aún.
        .columns.column-blanco
</template>


<script>
  import NavBarSolicitudes from '@/components/solicitudes_Componentes/layout/NavBarSolicitudes.vue'
  import Loader from '@/components/shared/Loader.vue'
  import mySwitch from '@/components/checklist_Componentes/switch.vue'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import ModalAceptar from '@/components/solicitudes_Componentes/layout/ModalAceptar.vue'
  import ModalRechazar from '@/components/solicitudes_Componentes/layout/ModalRechazar.vue'
  import ModalCancelarRechazo from '@/components/solicitudes_Componentes/layout/ModalCancelRechazo.vue'
  import ModalDeshacer from '@/components/solicitudes_Componentes/layout/ModalDeshacer.vue'
  import ModalEstadoAnterior from '@/components/solicitudes_Componentes/layout/ModalEstadoAnterior.vue'
  import ductosServices from '@/services/ducto'
  import InventarioServices from '../../services/inventario/inventario';
  import ReportesServices from '@/services/reportes/reportes'
  
  export default {
    name: 'HomeSolicitudes',
    components: { NavBarSolicitudes, Loader, mySwitch, ModalAceptar, ModalRechazar, ModalCancelarRechazo, ModalDeshacer, ModalEstadoAnterior },
    data() {
      return {
        isLoading: true,
        limit: 0,
        hayDatos: false,
        solicitudes: [],
        modalStatus: false,
        contentModal: '',
        titleModal: '',
        modalStatusRechazar: false,
        contentModalR: '',
        titleModalR: '',
        modalStatusCancelR: false,
        contentModalCancelR: '',
        titleModalCancelR: '',
        modalStatusDeshacer: false,
        contentModalDeshacer: '',
        titleModalDeshacer: '',
        modalStatusAnterior_Next: false,
        contentModalAnterior_Next: '',
        titleModalAnterior_Next: '',
        actualModal: '',
        solicitud_selected: ''
      }
    },
    methods: {
      iniciarComponente () {
        this.obtenerSolicitudes()
      },
      obtenerSolicitudes () {

        /* Estados 
        1 = Solicitud cat 3 ((Exc. S/I))
        2 = Aceptada-Jefe Area (Exc. S/I)
        3 = Aceptada-Gerente Planta (Exc. S/I)
        3 = Solicitud (S/I)
        4 = Aceptada-S/I 
        5 = Presupuesto (Para aceptar por C.P. César)
        6 = Comprado (Marcar por César)
        7 = Entregado (Marcar por César)
        */

        switch (this.userLogin.categoria) {
          case 0:
            // admin general?:  ver_todos(estado=2) : ver_ubicacion(estado=2)
              if (this.userLogin.cargo === '000' || this.userLogin.cargo === '003') {
                InventarioServices.getSolicitudes_All()
                .then( res => {
                  console.log(res)
                  // let sol_jefeS_I = res.filter( sol => parseInt(sol.estado) >= 2)
                  let sol_all = res.filter( sol => parseInt(sol.estado) >= 3 )
                  // let sol_all = res.filter( sol => parseInt(sol.estado) >= 2 || parseInt(sol.estado) == 4)
                  if (sol_all.length > 0) {
                    this.solicitudes = sol_all
                    this.hayDatos = true
                  } else {
                    this.hayDatos = false
                  }
                })
              } else {
                // es gerente del ducto?: ver_ducto(estado=2) : ver_ubicacion(estado=2)
                if (this.userLogin.ubicacion === 'LPG_DUCTO') {
                console.log('LPG_DUCTO')
                InventarioServices.getSolicitudes_ducto()
                  .then( res => {
                    console.log(res)
                    // let sol_jefe = res.filter( sol => parseInt(sol.estado) >= 1)
                    if (res.length > 0) {
                      // this.solicitudes = res.filter( sol => sol.departamento !== '1' || sol.departamento !== '3' || sol.departamento !== '2')
                      let arrayS_1  = res.filter( sol => sol.departamento !== '1')
                      let arrayS_3  = arrayS_1.filter( sol => sol.departamento !== '3')
                      let arrayS_6  = arrayS_3.filter( sol => sol.departamento !== '6')
                      this.solicitudes = arrayS_6
                      this.hayDatos = true
                    } else {
                      this.hayDatos = false
                    }
                  })
                } else {
                  InventarioServices.getSolicitudes_ubicacion(this.userLogin.ubicacion, this.limit)
                    .then( res => {
                      console.log(res)
                      // let sol_Gerencia = res.filter( sol => parseInt(sol.estado) >= 1)
                      let sol_depto = res.filter( sol => parseInt(sol.estado) >= 2 )
                      if ( sol_depto.length > 0 ) {
                        let arrayS_1  = sol_depto.filter( sol => sol.departamento !== '1')
                        let arrayS_3  = arrayS_1.filter( sol => sol.departamento !== '3')
                        let arrayS_6  = arrayS_3.filter( sol => sol.departamento !== '6')
                        this.solicitudes = arrayS_6
                        this.hayDatos = true
                      } else {
                        this.hayDatos = false
                      }
                    })
                }
              }
            break
          case 1:
            InventarioServices.getSolicitudes_user(this.userLogin.id, this.limit)
              .then( res => {
                console.log(res)
                if (res.length > 0) {
                  this.solicitudes = res
                  this.hayDatos = true
                } else {
                  this.hayDatos = false
                }
              })
            break
          case 2:
            // Es de S/I?: ver_departamentoAll : ver_departamento_ubicacion
            if (this.userLogin.departamento === 3 || this.userLogin.departamento === 1) {
              InventarioServices.getSolicitudes_area(this.userLogin.departamento, this.limit)
                .then( res => {
                  console.log(res)
                  let sol_jefeS_I = res.filter( sol => parseInt(sol.estado) >= 3)
                  if (sol_jefeS_I.length > 0) {
                    this.solicitudes = sol_jefeS_I
                    this.hayDatos = true
                  } else {
                    this.hayDatos = false
                  }
                })
            } else {
              // Es de TPA, IRGE, CORP?: ver_departamento_ubicacion : ver_Ducto
              if (this.userLogin.ubicacion === 'IRGE' || this.userLogin.ubicacion === 'TPA' || this.userLogin.ubicacion === 'CORP') {
                  InventarioServices.getSolicitudes_depto(this.userLogin.departamento, this.limit)
                  .then( res => {
                    console.log(res)
                    if (res.length > 0) {
                      this.solicitudes = res.filter( sol => sol.ubicacion === this.userLogin.ubicacion)
                      this.hayDatos = true
                    } else {
                      this.hayDatos = false
                    }
                  })
              } else {
                InventarioServices.getSolicitudes_ubicacion(this.userLogin.ubicacion, 'ALL')
                  .then( res => {
                    console.log(res)
                    // let sol_jefe = res.filter( sol => parseInt(sol.estado) >= 1)
                    if (res.length > 0) {
                      // this.solicitudes = res.filter( sol => sol.departamento !== '1' || sol.departamento !== '3' || sol.departamento !== '2')
                      let arrayS_1  = res.filter( sol => sol.departamento !== '1')
                      let arrayS_3  = arrayS_1.filter( sol => sol.departamento !== '3')
                      let arrayS_6  = arrayS_3.filter( sol => sol.departamento !== '6')
                      this.solicitudes = arrayS_6
                      this.hayDatos = true
                    } else {
                      this.hayDatos = false
                    }
                  })
              }
            }
            
            break
          case 3:
            InventarioServices.getSolicitudes_user(this.userLogin.id, this.limit)
              .then( res => {
                console.log(res)
                if (res.length > 0) {
                  this.solicitudes = res
                  this.hayDatos = true
                } else {
                  this.hayDatos = false
                }
              })
            break
        
          default:
            break
        }

        setTimeout(() => {
          this.isLoading = false
        }, 250)
      },
      
      irSocilitud (id) {
        console.log(id)
      },
      
      cambiarEstado (solicitud) {
        /* Estados 
        1 = Solicitud cat 3 ((Exc. S/I))
        2 = Aceptada-Jefe Area (Exc. S/I)
        3 = Aceptada-Gerente Planta (Exc. S/I)
        3 = Solicitud (S/I)
        4 = Aceptada-S/I 
        5 = Presupuesto (Para aceptar por C.P. César)
        6 = Requisicion (Marcar por César)
        7 = Orden Compra (Marcar por César)
        8 = Entregado (Marcar por César)
        */

        this.solicitud_selected = solicitud
        let toast = null
        switch (this.userLogin.categoria) {
          case '0':
            switch (parseInt(this.solicitud_selected.estado)) {
              case 0:
                this.titleModalCancelR = 'Cancelar Rechazo'
                this.contentModalCancelR = '¿Desea cancelar el rechazo de la Solicitud?'
                this.modalStatusCancelR = true
                break
              case 1:
                console.log('No deberían verlos')
                break
              case 2:
                if (this.userLogin.cargo === '000') {
                  console.log('Gerente Gral. No debería realizar acciones aqui')
                  // this.titleModal = 'Aceptar o Rechazar'
                  // this.contentModal = '¿Desea aceptar o rechazar la Solicitud?'
                  // this.modalStatus = true  
                } else {
                  this.titleModal = 'Aceptar o Rechazar'
                  this.contentModal = '¿Desea aceptar o rechazar la Solicitud?'
                  this.modalStatus = true  
                }
                break
              case 3:
                if (this.userLogin.cargo === '000') {
                  console.log('Gerente Gral. No debería realizar acciones aqui')
                  // this.titleModalDeshacer = 'Regresar a estado anterior'
                  // this.contentModalDeshacer = '¿Desea Regresar al estado anterior?'
                  // this.modalStatusDeshacer = true
                } else {
                  this.titleModalDeshacer = 'Regresar a estado anterior'
                  this.contentModalDeshacer = '¿Desea Regresar al estado anterior?'
                  this.modalStatusDeshacer = true
                }
                break
              case 4:
                if (this.userLogin.cargo === '000') {
                  this.titleModal = 'Aceptar o Rechazar'
                  this.contentModal = '¿Desea aceptar o rechazar la Solicitud?'
                  this.modalStatus = true
                } else {

                  toast = this.$toasted.show(`No se pueden realizar movimientos, debe esperar sea aceptada su solicitud por su la Gerencia General.`, { 
                    theme: "toasted-primary", 
                    position: "bottom-right", 
                    duration : 5000,
                    iconPack: 'fontawesome',
                    icon: 'ban',
                    action : {
                      text : 'Ok',
                      onClick : (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                  })
                }
                break
              case 5:
                if (this.userLogin.cargo === '000') {
                  this.titleModalDeshacer = 'Cambiar Estado'
                  this.contentModalDeshacer = '¿Desea cambiar su estado a Almacenado?'
                  this.modalStatusDeshacer = true
                } else {
                  console.log('Otros Gerentes No pueden Realizar acciones')
                }
                break
              case 6:
                console.log('Estado 6')
                break
              case 7:
                console.log('Estado 7')
                break
              case 8:
                  console.log('Estado 8')
                break
              default:
                break
            }            
            break
          case '1':
            console.log('No esta permitido para usuarios Asistentes')
            this.modalStatus = false
            break
          case '2':
            switch (parseInt(this.solicitud_selected.estado)) {
              case 0:
                this.titleModalCancelR = 'Cancelar Rechazo'
                this.contentModalCancelR = '¿Desea cancelar el rechazo de la Solicitud?'
                this.modalStatusCancelR = true  
                break
              case 1:
                if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3) {
                  console.log('No deberían verlos')
                } else {
                  this.titleModal = 'Aceptar o Rechazar'
                  this.contentModal = '¿Desea aceptar o rechazar la Solicitud?'
                  this.modalStatus = true
                }
                break
              case 2:
                if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3) {
                  console.log('No deberían verlos Jefes de Area sistemas e instrumentación')
                  toast = this.$toasted.show(`No se pueden realizar movimientos, debe esperar sea aceptada su solicitud por su Gerente en Planta.`, { 
                    theme: "toasted-primary", 
                    position: "bottom-right", 
                    duration : 5000,
                    iconPack: 'fontawesome',
                    icon: 'ban',
                    action : {
                      text : 'Ok',
                      onClick : (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                  })

                } else {
                  console.log('regresar a Estado anterior')
                  this.titleModalDeshacer = 'Cambiar Estado'
                  this.contentModalDeshacer = '¿Desea regresar a su estado anterior?'
                  this.modalStatusDeshacer = true
                }
                break
              case 3:
                if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3) {
                  this.titleModal = 'Aceptar o Rechazar'
                  this.contentModal = '¿Desea aceptar o rechazar la Solicitud?'
                  this.modalStatus = true
                } else {
                  console.log('No pueden Realizar acciones')
                  toast = this.$toasted.show(`No se pueden realizar movimientos, debe esperar sea aceptada su solicitud por su la Jefatura de Sistemas.`, { 
                    theme: "toasted-primary", 
                    position: "bottom-right", 
                    duration : 5000,
                    iconPack: 'fontawesome',
                    icon: 'ban',
                    action : {
                      text : 'Ok',
                      onClick : (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                  })                }
                break
              case 4:
                if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3) {
                  console.log(' Estado 4 Jefes de area de sistemas e instrumentación')
                  this.titleModalDeshacer = 'Cambiar Estado'
                  this.contentModalDeshacer = '¿Desea regresar a su estado anterior?'
                  this.modalStatusDeshacer = true

                } else {
                  let areaStr = ''
                  switch (this.solicitud_selected.area) {
                    case '1':
                      areaStr = 'Instumentación'
                      break
                    case '2':
                      areaStr = 'Administración'
                      break
                    case '3':
                      areaStr = 'Sistemas'
                      break
                    default:
                      break
                  }
                  
                  toast = this.$toasted.show(`No se pueden realizar movimientos, debe esperar sea aceptada su solicitud por su la Jefatura de ${areaStr}.`, { 
                    theme: "toasted-primary", 
                    position: "bottom-right", 
                    duration : 5000,
                    iconPack: 'fontawesome',
                    icon: 'ban',
                    action : {
                      text : 'Ok',
                      onClick : (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                  })
                }
                break
              case 5:
                toast = this.$toasted.show(`No se pueden realizar movimientos, debe esperar sea comprado el bien o servicio.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 5000,
                  iconPack: 'fontawesome',
                  icon: 'ban',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
                break
              case 6:
                toast = this.$toasted.show(`No se pueden realizar movimientos, debe esperar sea comprado el bien o servicio.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 5000,
                  iconPack: 'fontawesome',
                  icon: 'ban',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
                break
              case 7:
                console.log('No pueden Realizar acciones')
                break
            
              default:
                break
            }
            
            break
          case '3':
            if (parseInt(this.solicitud_selected.estado) == 0) {
              this.titleModalCancelR = 'Solicitar'
              this.contentModalCancelR = '¿Desea realizar de nuevo la solicitud?'
              this.modalStatusCancelR = true
              this.modalStatus = false    
            } else {
              toast = this.$toasted.show(`No se pueden realizar movimientos, debe esperar sea aceptada su solicitud.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 5000,
                iconPack: 'fontawesome',
                icon: 'ban',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
            }
            break
        
          default:
            break
        }
      },
      
      aceptarSolicitud (value) {
        this.modalStatus = false
        this.isLoading = true
        console.log(value)

        if (this.solicitud_selected) {
          let estInt = parseInt(this.solicitud_selected.estado)
          let newEstaInt = 0
          switch (value) {
            case 'c':
              console.log('No hacemos nada')
              break
            case 'r':
              // switch (estInt) {
              //   case 1:
              //     newEstaInt = 0
              //     break
              //   case 2:
              //     newEstaInt = 0
              //     break
              //   case 3:
              //     newEstaInt = 0
              //     break
              //   case 4:
              //     newEstaInt = 0
              //     break
              //   case 5:
              //     newEstaInt = estInt - 1
              //     break
              //   case 6:
              //     newEstaInt = estInt - 1
              //     break
              // }

              newEstaInt = 0
              InventarioServices.updateSolicitud_estado(this.solicitud_selected.id, newEstaInt)
                .then( res => {
                  console.log(res)
                  if (res.success) {
                    this.obtenerSolicitudes()
                  } else {
                    console.log('Error')
                  }
                })
              break
            case 'ok':
              newEstaInt = estInt + 1
              InventarioServices.updateSolicitud_estado(this.solicitud_selected.id, newEstaInt)
                .then( res => {
                  console.log(res)
                  if (res.success) {
                    this.obtenerSolicitudes()
                  } else {
                    console.log('Error')
                  }
                })
              break
          }
        } else {
          console.log('No hay solicitud seleccionada')
        }
        this.isLoading = false
      },

      rechazarSolicitud (value) {
        this.modalStatusRechazar = false
        this.isLoading = true
        console.log(value)

        if (value !== 'c') {
          if (this.solicitud_selected) {
            let estInt = parseInt(this.solicitud_selected.estado)
            let newEstaInt = 0
            // switch (this.userLogin.categoria) {
            //   case '2':
            //     newEstaInt = estInt - 1
            //     break
            //   case '0':
                
            //     newEstaInt = 0
            //     break
            // }
            InventarioServices.updateSolicitud_estado(this.solicitud_selected.id, newEstaInt)
              .then( res => {
                console.log(res)
                if (res.success) {
                  this.obtenerSolicitudes()
                } else {
                  console.log('Error')
                }
              })
          } else {
            console.log('Error no hay solicitud seleccionada ')
          }
        } else {
          console.log('Cerrar Solicitud')
          this.modalStatusRechazar = false
        }
        this.isLoading = false
      },

      cancelarRechazo (value) {
        this.modalStatusCancelR = false
        this.isLoading = true
        console.log(value)

        if (value === 'ok') {
          if (this.solicitud_selected) {
            let estInt = parseInt(this.solicitud_selected.estado)
            let newEstaInt = 0

            switch (this.userLogin.categoria) {
              case 2:
                if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3) {
                  newEstaInt = estInt + 3
                } else {
                  newEstaInt = estInt + 1
                }
                break
              case 0:
                if (this.userLogin.cargo==='000') {
                  newEstaInt = estInt + 4
                } else {
                  newEstaInt = estInt + 2
                }
                break
              case 1:
                newEstaInt = estInt + 2
                break
              case 3:
                newEstaInt = estInt + 1
                break
            }
            
            InventarioServices.updateSolicitud_estado(this.solicitud_selected.id, newEstaInt)
              .then( res => {
                console.log(res)
                if (res.success) {
                  this.obtenerSolicitudes()
                } else {
                  console.log('Error')
                }
              })
          } else {
            console.log('Error no hay solicitud seleccionada ')
          }
        }
        this.isLoading = false
      },

      deshacerAceptar (value) {
        this.modalStatusDeshacer = false
        this.isLoading = true
        console.log(value)

        if (value === 'ok') {
          if (this.solicitud_selected) {
            let estInt = parseInt(this.solicitud_selected.estado)
            let newEstaInt = 0
            newEstaInt = estInt - 1
            InventarioServices.updateSolicitud_estado(this.solicitud_selected.id, newEstaInt)
              .then( res => {
                console.log(res)
                if (res.success) {
                  this.obtenerSolicitudes()
                } else {
                  console.log('Error')
                }
              })
          } else {
            console.log('Error no hay solicitud seleccionada ')
          }
        }
        this.isLoading = false
      },

      anterior_next (value) {
        this.modalStatusAnterior_Next = false
        this.isLoading = true
        console.log(value)

        if (this.solicitud_selected) {
          let estInt = parseInt(this.solicitud_selected.estado)
          let newEstaInt = 0

          switch (value) {
            case 'c':
              console.log('cancel')
              break
            case 'a':
              newEstaInt = estInt - 1  
              break
            case 'n':
              newEstaInt = estInt + 1  
              break
            default:
              break
          }
          
          if (value !== 'c') {
            InventarioServices.updateSolicitud_estado(this.solicitud_selected.id, newEstaInt)
              .then( res => {
                console.log(res)
                if (res.success) {
                  this.obtenerSolicitudes()
                } else {
                  console.log('Error')
                }
              })
          }
        } else {
          console.log('Error no hay solicitud seleccionada ')
        }
        
        this.isLoading = false
      },

      getPrioridad (prioridad) {
        switch (prioridad) {
          case '0':
            return '<span class="tag is-light">Baja</span>'
            break
          case '1':
            return '<span class="tag is-warning">Normal</span>'
            break
          case '2':
            return '<span class="tag is-danger">Urgente</span>'
            break
        
          default:
            break
        }
      },

      getEstado (estado, depto, area) {
        /* Estados 
        1 = Solicitud cat 3 ((Exc. S/I))
        2 = Aceptada-Jefe Area (Exc. S/I)
        3 = Aceptada-Gerente Planta (Exc. S/I)
        3 = Solicitud (S/I)
        4 = Aceptada-S/I 
        5 = Presupuesto (Para aceptar por C.P. César)
        6 = Comprado (Marcar por César)
        7 = Almacenado (Marcar por César)
        8 = Asignado (Marcar por César)
        */

        switch (estado) {
          case '0':
            return '<span class="tag is-danger">Rechazada</span>'
            break
          case '1':
            return '<span class="tag is-warning">Solicitud</span>'
            break
          case '2':
            let text = ''
            
            if (depto === '2' || depto === '21') {
              text = '<span class="tag is-warning">Solicitada</span>'
            } else {
              text = '<div class="control"><div class="tags has-addons"><span class="tag is-dark">Aceptada</span><span class="tag is-light">Jefe Area</span></div></div>'
            }
            return text
            break
          case '3':
            let text3 = ''
            if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3) {
              if (depto === '1' || depto === '3') {
                text3 = '<span class="tag is-warning">Solicitada</span>'
              } else {
                text3 = '<div class="control"><div class="tags has-addons"><span class="tag is-dark">Aceptada</span><span class="tag is-info">Gerencia</span></div></div>'
              }
            } else {
              text3 = '<div class="control"><div class="tags has-addons"><span class="tag is-dark">Aceptada</span><span class="tag is-info">Gerencia</span></div></div>'
            }
            return text3
            break
          case '4':
            let text4 = ''
            switch (area) {
              case '1':
                text4 = '<div class="control"><div class="tags has-addons"><span class="tag is-dark">Aceptada</span><span class="tag is-success">Jefe Instrum.</span></div></div>'    
                break
              case '3':
                text4 = '<div class="control"><div class="tags has-addons"><span class="tag is-dark">Aceptada</span><span class="tag is-success">Jefe Sistemas</span></div></div>'    
                break
              default:
                break
            }
            return text4
            break
          case '5':
            return '<span class="tag is-primary">Presupuesto</span>'
            break
          case '6':
            return '<span class="tag is-success">Requisición</span>'
            break
          case '7':
            return '<span class="tag is-black">Orden de Compra</span>'
            break
          case '8':
            return '<span class="tag is-black">Almacenado</span>'
            break
          case '8':
            return '<span class="tag is-black">Asignado</span>'
            break
          default:
            break
        }
      },

      imprimirReporte(t) {
        this.isLoading = true
        const api_url = window.location.hostname
        const storage = '/var/www/html/reportesApp/'

        ReportesServices.getActividad(t.id_actividad)
          .then((data) => {
            this.actividadSelect = this.convertirActividad(data)
            console.log(this.actividadSelect)
            this.actividadSelect.evidencias = this.actividadSelect.evidencias.map(this.convetirEvidencias)

            let fRealiza = `${storage}${this.actividadSelect.usuario.avatar}`
            let fSupervisa = ''

            if (this.actividadSelect.estado > 1) {
              fSupervisa = `${storage}${this.actividadSelect.jefeArea.avatar}`
            } else {
              fSupervisa = `${storage}images/firmas/default.png`
            }

            let array_evidencias = [ 
              { id: 1, path: `${storage}images/firmas/default.png` }, 
              { id: 2, path: `${storage}images/firmas/default.png` }, 
              { id: 3, path: `${storage}images/firmas/default.png` }, 
              { id: 4, path: `${storage}images/firmas/default.png` }, 
              { id: 5, path: `${storage}images/firmas/default.png` }, 
              { id: 6, path: `${storage}images/firmas/default.png` }, 
              { id: 7, path: `${storage}images/firmas/default.png` }, 
              { id: 8, path: `${storage}images/firmas/default.png` }, 
              { id: 9, path: `${storage}images/firmas/default.png` }, 
              { id: 10, path: `${storage}images/firmas/default.png` }, 
              { id: 11, path: `${storage}images/firmas/default.png` }, 
              { id: 12, path: `${storage}images/firmas/default.png` }
            ]
            let index = 0
            this.actividadSelect.evidencias.map((evi) => {
              if (evi) {
                array_evidencias[index].path = evi.path
              }
              index++
            })

            let fechaRegistro = moment(this.actividadSelect.fecha_Reg).format('YYYY-MM-DD')
            console.log(this.actividadSelect.permisoBD)

            ReportesServices.getActualizaciones(t.id_actividad)
              .then((resp) => {
                let numUpdates = parseInt(resp.numActs)
                console.log(numUpdates)
                const linkI1 = `https://${api_url}/reportesApp/server/actividadesFile1.php?id=${t.id_actividad}&fRealiza=${fRealiza}&fSupervisa=${fSupervisa}`;
                const linkI2 = `https://${api_url}/reportesApp/server/actividadesFile2.php?id=${t.id_actividad}&fRealiza=${fRealiza}&fSupervisa=${fSupervisa}`;
                const linkI3 = `https://${api_url}/reportesApp/server/actividadesFile3.php?id=${t.id_actividad}&evidencia1=${array_evidencias[0].path}&evidencia2=${array_evidencias[1].path}&evidencia3=${array_evidencias[2].path}&evidencia4=${array_evidencias[3].path}&evidencia5=${array_evidencias[4].path}&evidencia6=${array_evidencias[5].path}&evidencia7=${array_evidencias[6].path}&evidencia8=${array_evidencias[7].path}&evidencia9=${array_evidencias[8].path}&evidencia10=${array_evidencias[9].path}&evidencia11=${array_evidencias[10].path}&evidencia12=${array_evidencias[11].path}&fRealiza=${fRealiza}&fSupervisa=${fSupervisa}`;
                const linkI4 = `https://${api_url}/reportesApp/server/actividadesFile4.php?id=${t.id_actividad}&fRealiza=${fRealiza}&fSupervisa=${fSupervisa}`;
                const linkR = `https://${api_url}/reportesApp/server/reporteActividadesAllP.php?idAct=${t.id_actividad}&ubicacion=${t.ubicacion}&fechaReg=${fechaRegistro}&permiso=${this.actividadSelect.permisoBD}&acts=${numUpdates}`;
                const linkB = `https://${api_url}/reportesApp/server/borrarFiles.php?idAct=${t.id_actividad}&ubicacion=${t.ubicacion}&fechaReg=${fechaRegistro}`;
                this.getReporte(linkI1, linkI2, linkI3, linkI4, linkR, linkB, numUpdates)  
              })
              .catch((e) => {
                this.isLoading = false
                this.displayToast(e.message, 'ban', 'OK')
              })
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          })
      },
      convertirActividad( act) {
        const storage = '/var/www/html/reportesApp/'

        let permiso = ''
        if (act.permiso === 'N/A' || act.permiso === '') {
          permiso = ''
        } else {
          permiso = `${storage}${act.imagen_permiso}`
        }

        return {
          ...act,
          area: parseInt(act.area),
          estado: parseInt(act.estado),
          permisoBD: permiso
        }
      },

      convetirEvidencias(evi) {
        const storage = '/var/www/html/reportesApp/'
        let absolutePath = `${storage}${evi.ruta}`
        return {
          ...evi,
          path: absolutePath
        }
      },

      async getReporte(link1, link2, link3, link4, linkR, linkB, numUpdates) {
        
        try {
          const response1 = await fetch(link1)
          const data1 = await response1.json()
          console.log(data1)
          if (data1.success) {

            try {
              const response2 = await fetch(link2)
              const data2 = await response2.json()  
              console.log(data2)
              if (data2.success) {
                
                try {
                  const response3 = await fetch(link3)
                  const data3 = await response3.json()
                  console.log(data3)  

                  if (data3.success) {

                    if ( parseInt(numUpdates) > 0) {
                      try {
                          const response4 = await fetch(link4)
                          const data4 = await response4.json()
                          if (data4.success) {
                            open(linkR, '_blank')
                            setTimeout(() => {
                              fetch(linkB)
                                .then(resB => resB.json())
                                .then(dataB=> {
                                  console.log(dataB)
                                  this.isLoading = false
                                })
                            }, 2500)
                          } else {
                            this.displayToast(data4.respuesta, 'ban', 'OK')    
                            this.isLoading = false
                          }
                          
                        } catch (error) {
                          this.isLoading = false
                          this.displayToast(error, 'ban', 'OK')
                        }
                    } else {
                      open(linkR, '_blank')
                        setTimeout(() => {
                          fetch(linkB)
                            .then(resB => resB.json())
                            .then(dataB=> {
                              console.log(dataB)
                              this.isLoading = false
                            })
                        }, 2500)
                    }

                  } else {
                    this.displayToast(data3.respuesta, 'ban', 'OK')    
                    this.isLoading = false
                  }
                } catch (error) {
                  this.isLoading = false
                  this.displayToast(error, 'ban', 'OK')
                }

              } else {
                this.displayToast(data2.respuesta, 'ban', 'OK')  
                this.isLoading = false
              }

            } catch (error) {
              this.isLoading = false
              this.displayToast(error, 'ban', 'OK')
            }

          } else {
            this.displayToast(data1.respuesta, 'ban', 'OK')
            this.isLoading = false
          }

        } catch (error) {
          this.isLoading = false
          this.displayToast(error.message, 'ban', 'OK')
        }
      },
      backPage() {
        this.$router.back()
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    }

  }
</script>

<style lang="css" scoped>
  .table-responsive {
    overflow-x: auto;
  }

  .column-blanco {
    padding-bottom: 50px;
  }
</style>


// WEBPACK FOOTER //
// src/components/solicitudes_Componentes/HomeSolicitudes.vue